import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import "rxjs/add/operator/map";
import { Observable } from "rxjs/Observable";
import { of } from "rxjs/observable/of";
import { catchError, map, tap } from "rxjs/operators";

import { LaborGuideItem } from "./labor-guide-item";
import { NeededPartItem } from "./neededpartitem";

const httpOptions = {
  headers: new HttpHeaders({
    "Content-Type": "application/json",
    Accept: "application/json"
  })
};

@Injectable()
export class LaborService {
  private appDataUrl =
    "https://bs7x45gtb6.execute-api.us-east-2.amazonaws.com/appdata";

  private apiUrl = "https://labor.azurewebsites.net/";
  // private apiUrl = "http://localhost:8080/";

  private prodemandApi =
    "https://ouzxsfiy14.execute-api.us-east-2.amazonaws.com/prodemand";
  private alldataApi =
    "https://s05xwicm54.execute-api.us-east-2.amazonaws.com/alldata";

  private unconfirmedUrl = "https://applicationdata.azurewebsites.net/v1/labor/unconfirmed";
  private updateUrl = "https://applicationdata.azurewebsites.net/v1/labor/confirm";
  private laborUrl = this.apiUrl + "labor"; // URL to web api
  private addonUrl = this.apiUrl + "addon"; // URL to web api
  private neededPartUrl = this.apiUrl + "neededPart"; // URL to web api
  private deleteLaborUrl = this.apiUrl + "deleteLabor/"; // URL to web api
  private verifylaborUrl = this.apiUrl + "verifyLabor"; // URL to web api
  private deleteAddonUrl = this.apiUrl + "deleteAddon/"; // URL to web api
  private changeCategoryUrl = this.apiUrl + "changeParent/"; // URL to web api
  private updateLaborTimePathUrl = this.apiUrl + "updateLaborTimePath"; // URL to web api
  private copyUrl = this.apiUrl + "copy"; // URL to web api

  constructor(private http: HttpClient) { }

  public getCategories(): Observable<any> {
    return this.http.get("/assets/category.json");
  }

  public getAllDataCategories(vinNumber): Observable<any> {
    return this.http.get(this.alldataApi, {
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
      params: {
        vinNumber: vinNumber,
        pathLabor: "",
        action: "getCategories"
      }
    });
  }

  public getAllDataDetail(vinNumber, pathData): Observable<any> {
    return this.http.get(this.alldataApi, {
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
      params: {
        vinNumber: vinNumber,
        pathLabor: pathData,
        action: "getDetail"
      }
    });
  }

  public getUnconfirmed(): Observable<any[]> {
    return this.http.get<any[]>(this.unconfirmedUrl);
  }

  update(labor: any): Observable<any> {
    labor.confirmed = true;
    const jsonString = JSON.stringify(labor);
    return this.http.put(this.updateUrl, jsonString, httpOptions);
  }

  public searchLaborName(vinNumber, searchedText, fName): Observable<any> {
    return this.http.get(this.prodemandApi, {
      params: {
        vinNumber: vinNumber,
        searchedText: searchedText,
        path: "",
        fName: fName,
        pathName: ""
      }
    });
  }

  public getLaborDetails(vinNumber, path, fName): Observable<any> {
    return this.http.get(this.prodemandApi, {
      params: {
        vinNumber: vinNumber,
        searchedText: "",
        path: path,
        fName: fName,
        pathName: ""
      }
    });
  }

  public getLabors(): Observable<any> {
    return this.http.get(this.laborUrl);
  }

  public getAddons(): Observable<any> {
    return this.http.get(this.addonUrl);
  }

  public deleteAddon(addonId: any): Observable<any> {
    return this.http.get(this.deleteAddonUrl + "/" + addonId);
  }

  public getLaborById(addonId: any): Observable<any> {
    return this.http.get(this.laborUrl + "/" + addonId);
  }

  public addAddon(laborIds: any): Observable<any> {
    return this.http.get(this.addonUrl + "/" + laborIds);
  }

  public getNeededParts(laborId: any): Observable<any> {
    return this.http.get(this.neededPartUrl + "/" + laborId);
  }

  public deleteLabor(laborId: any): Observable<any> {
    return this.http.post<LaborGuideItem>(
      this.deleteLaborUrl + laborId,
      null,
      httpOptions
    );
  }

  public verifyLabor(laborId: any, isVerified: any): Observable<any> {
    var data = {
      laborguideId: laborId,
      isVerified: isVerified
    };
    return this.http.post<LaborGuideItem>(
      this.verifylaborUrl,
      data,
      httpOptions
    );
  }

  public updateNeededPart(
    neededParts: NeededPartItem[]
  ): Observable<NeededPartItem> {
    let bodyData = {
      NeededParts: neededParts
    };
    console.log(neededParts);
    return this.http
      .put<NeededPartItem>(this.neededPartUrl, bodyData, httpOptions)
      .pipe(
        tap((labor: NeededPartItem) => console.log("update laborguide")),
        catchError(this.handleError<NeededPartItem>("update labor error"))
      );
  }

  public updateLabor(
    labor: LaborGuideItem,
    neededParts: NeededPartItem[]
  ): Observable<LaborGuideItem> {
    let bodyData = {
      Labor: labor,
      NeededParts: neededParts
    };
    console.log(bodyData);
    return this.http.put<LaborGuideItem>(this.laborUrl, bodyData).pipe(
      tap((labor: LaborGuideItem) => console.log("update laborguide")),
      catchError(this.handleError<LaborGuideItem>("update labor error"))
    );
  }

  public changeCategory(labor: LaborGuideItem, parentId: any): Observable<any> {
    return this.http.post<LaborGuideItem>(
      this.changeCategoryUrl + parentId,
      labor,
      httpOptions
    );
  }

  public updateLaborTimePath(
    labor: LaborGuideItem,
    prodemandPath: any,
    allDataPath: any
  ): Observable<any> {
    var data = {
      addonId: labor.AddonId,
      prodemandPath: prodemandPath,
      allDataPath: allDataPath
    };
    return this.http.post<LaborGuideItem>(
      this.updateLaborTimePathUrl,
      data,
      httpOptions
    );
  }

  public copy(terminals: LaborGuideItem[], parentId: any): Observable<any> {
    var data = {
      Terminals: terminals,
      ParentID: parentId
    };
    console.log(data);
    return this.http.post(this.copyUrl, data, httpOptions);
  }

  public saveAppData(
    partNumbers: any,
    labor: LaborGuideItem,
    pathData: any,
    vehicleInfo: any
  ): Observable<any> {
    var data = {
      addonId: labor.AddonId,
      vehicleInfo: vehicleInfo,
      pathData: pathData,
      laborName: labor.Title,
      partNumbers: partNumbers,
      methodName: "saveAppData"
    };
    return this.http.post<LaborGuideItem>(this.appDataUrl, data, httpOptions);
  }

  public saveVehicle(vehicleInfo, laborName): Observable<any> {
    var data = {
      vehicleInfo: vehicleInfo,
      methodName: "checkVehicleInfo",
      laborName: laborName
    };
    return this.http.post<any>(this.appDataUrl, data, httpOptions);
  }

  public getAppDataByVehicle(vehicleInfo, laborName): Observable<any> {
    var data = {
      vehicleInfo: vehicleInfo,
      methodName: "getAppDataByVehicle",
      laborName: laborName
    };
    return this.http.post<any>(this.appDataUrl, data, httpOptions);
  }

  public addLabor(
    labor: LaborGuideItem,
    neededParts: NeededPartItem[]
  ): Observable<LaborGuideItem> {
    labor.Description = labor.Description.toString().trim();
    let bodyData = {
      Labor: labor,
      NeededParts: neededParts
    };

    return this.http
      .post<LaborGuideItem>(this.laborUrl, bodyData, httpOptions)
      .pipe(
        tap((labor: LaborGuideItem) => console.log("added laborguide")),
        catchError(this.handleError<LaborGuideItem>("addLabor"))
      );
  }

  addHero(labor: LaborGuideItem): Observable<LaborGuideItem> {
    return this.http
      .post<LaborGuideItem>(this.laborUrl, labor, httpOptions)
      .pipe(
        tap((labor: LaborGuideItem) => console.log("added labarguide")),
        catchError(this.handleError<LaborGuideItem>("addHero"))
      );
  }

  private handleError<T>(operation = "operation", result?: T) {
    return (error: any): Observable<T> => {
      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }
}
